import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { FAQSchema } from '@/components/seo/FAQSchema';

// Polished, collapsible FAQ block + FAQPage JSON-LD (AEO). Matches the country-page
// `.uk-faqs` accordion styling. `faqs` = [{ question, answer }].
export const GuideFaq = ({ faqs }) => {
  if (!faqs || faqs.length === 0) return null;
  return (
    <section className="uk-guide-faq" aria-labelledby="faq" data-testid="guide-faq">
      <span className="uk-eyebrow">Questions, answered<span className="uk-sep" /></span>
      <h2 id="faq" data-testid="guide-faq-heading">Frequently asked questions</h2>
      <Accordion type="single" collapsible className="uk-faqs" data-testid="guide-faq-accordion">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`guide-faq-item-${i}`}>
            <AccordionTrigger data-testid={`guide-faq-q-${i}`}>{f.question}</AccordionTrigger>
            <AccordionContent data-testid={`guide-faq-a-${i}`}>{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <FAQSchema faqs={faqs} />
    </section>
  );
};

export default GuideFaq;
